import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { Alert, Badge } from "components/bootstrap";
import { ConfirmDialog, Spinner, Switch } from "components/common";
import useAIConfiguration from "ai/hooks/useAIConfiguration";
import useAIConfigurationMutations from "ai/hooks/useAIConfigurationMutations";
const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.md};
  `
);
const Description = styled.div`
  flex-grow: 1;
`;
const Title = styled.h3(
  ({ theme }) => css`
    margin: 0;
    font-weight: bold;
    font-size: ${theme.fonts.size.large};
  `
);
const HelpText = styled.p`
  margin: 0;
`;
const DisabledAlert = styled(Alert)(
  ({ theme }) => css`
    margin-top: ${theme.spacings.sm};
  `
);
const AIFeaturesToggle = () => {
  const { t } = useTranslation("enterprise_ai");
  const {
    data: { isEnabled },
    isLoading
  } = useAIConfiguration();
  const { enable, disable } = useAIConfigurationMutations();
  const [showDisableConfirm, setShowDisableConfirm] = useState(false);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const onChange = () => isEnabled ? setShowDisableConfirm(true) : enable();
  const onConfirmDisable = () => disable().finally(() => setShowDisableConfirm(false));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement(Switch, { "aria-label": t("ai_features_toggle.title"), checked: isEnabled, onChange }), /* @__PURE__ */ React.createElement(Description, null, /* @__PURE__ */ React.createElement(Title, null, t("ai_features_toggle.title")), /* @__PURE__ */ React.createElement(HelpText, null, isEnabled ? t("ai_features_toggle.help_enabled") : t("ai_features_toggle.help_disabled"))), /* @__PURE__ */ React.createElement(Badge, { color: isEnabled ? "success" : "gray", variant: "light", dot: true }, isEnabled ? t("ai_features_toggle.badge_on") : t("ai_features_toggle.badge_off"))), !isEnabled && /* @__PURE__ */ React.createElement(DisabledAlert, { bsStyle: "warning" }, t("ai_features_toggle.disabled_alert")), showDisableConfirm && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: true,
      title: t("ai_features_toggle.turn_off_title"),
      btnConfirmText: t("ai_features_toggle.turn_off_confirm"),
      onConfirm: onConfirmDisable,
      onCancel: () => setShowDisableConfirm(false)
    },
    t("ai_features_toggle.turn_off_message")
  ));
};
export default AIFeaturesToggle;
